import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getCaseStudyCommarecPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/reference/commarec-nakopne-i-vasi-logistiku",
		[Locale.en]: "/reference/commarec-logistics-platform",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
